import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  useGetBrTypeOptions,
  useGetBrCategoryOptions,
  useGetContracts
} from '../../../../../../queries';
import { ControlledSelect } from '../../../../../shared';
import ValidFromAndToSection from './ValidFromAndToSection';

const NoTravelArrangementReportSection = () => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.procedures.reports'
  });
  const { control } = useFormContext();
  const { data: contracts } = useGetContracts();
  const { data: brTypeOptions } = useGetBrTypeOptions();
  const { data: brCategoryOptions } = useGetBrCategoryOptions();

  return (
    <>
      <ValidFromAndToSection />
      <ControlledSelect
        variant="outlined"
        control={control}
        name="contract_list"
        label={t('contract')}
        options={contracts ?? []}
      />
      <ControlledSelect
        variant="outlined"
        control={control}
        name="cc_category_list"
        label={t('ccCategoryList')}
        options={brCategoryOptions ?? []}
      />
      <ControlledSelect
        variant="outlined"
        control={control}
        name="cc_type_list"
        label={t('ccTypeList')}
        options={brTypeOptions ?? []}
      />
    </>
  );
};

export default NoTravelArrangementReportSection;
